import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Checkout = () => {
  const location = useLocation();
  const { clientSecret } = location.state || {};

  const fetchClientSecret = useCallback(() => {
    if (clientSecret) {
      return Promise.resolve(clientSecret);
    }

    // Throw error if clientSecret is not passed
    throw new Error('clientSecret is required but was not provided.');
  }, [clientSecret]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default Checkout;
